import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { EBPMSService } from "../ebpms.service";
import { EBPMSStatus } from "../_models/EBPMSStatus";
import { IBrakePerformanceScoreHistory } from "../_models/IBrakePerformanceScoreHistory";
import "./ebpms-vehicle-history.component.scss";

@Component({
    selector: 'ebpms-vehicle-history',
    template: require("./ebpms-vehicle-history.component.html")
})
export class EBPMSVehicleHistoryComponent implements OnChanges, OnInit {
    @Input() vehicleId: number;

    history: IBrakePerformanceScoreHistory[];
    status: EBPMSStatus;

    constructor(private readonly ebpmsService: EBPMSService) {
    }

    ngOnInit(): void {
    }

    async ngOnChanges(): Promise<void> {
        await this.loadData();
    }

    // ---

    private async loadData(): Promise<void> {
        this.history = await this.ebpmsService.getBrakePerformanceScoreHistory(this.vehicleId);
        var statuses = await this.ebpmsService.getBrakePerformanceStatusesForVehicle(this.vehicleId);

        this.history = this.ebpmsService.mapStatusToScoreHistory(this.history, statuses);

        this.status = this.history[this.history.length - 1].Status;
    }
}
